export const TextTransformClasses = {
    UPPERCASE: ['wf-uppercase'],
    LOWERCASE: ['wf-lowercase'],
    CAPITALIZE: ['wf-capitalize'],
    NORMAL_CASE: ['wf-normal-case']
}